import { Box } from '@mui/material';
import React from 'react';
import { FormattedMessage } from 'react-intl';

function SecuredTitleIcon({ post }: any) {
  if (post.has_secured_strategy_contribute) {
    return (
      <Box sx={{ mb: 2 }}>
        <span role="img" aria-label="lock icon">
          🔒 <FormattedMessage id="SECURED_STRATEGIES.TOOLTIP" />
        </span>
      </Box>
    );
  }

  return null;
}

export default SecuredTitleIcon;
